// import '../src/App.css';
import RouterFile from './routes';

function App() {
  return (
    <div className="App">
      <RouterFile />
      {/* <Home /> */}
      <nav>
        {/* <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
        </ul> */}
      </nav>
    </div>
  );
}

export default App;
